export default "__VITE_ASSET__B4DH_1Fn__"